export const set_version = (json_data) => ({
  type: 'set_version',
  payload: json_data,
});
export const remove_version = (json_data) => ({
  type: 'remove_version',
  payload: json_data,
});
